import _initializerDefineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerDefineProperty.js";
import _defineProperty from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _applyDecoratedDescriptor from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/applyDecoratedDescriptor.js";
import _initializerWarningHelper from "/var/www/discourse/node_modules/@babel/runtime/helpers/esm/initializerWarningHelper.js";
var _class, _descriptor, _descriptor2, _EverythingSectionLink_brand;
function _classPrivateMethodInitSpec(e, a) { _checkPrivateRedeclaration(e, a), a.add(e); }
function _checkPrivateRedeclaration(e, t) { if (t.has(e)) throw new TypeError("Cannot initialize the same private elements twice on an object"); }
function _classPrivateGetter(s, r, a) { return a(_assertClassBrand(s, r)); }
function _assertClassBrand(e, t, n) { if ("function" == typeof e ? e === t : e.has(t)) return arguments.length < 3 ? t : n; throw new TypeError("Private element is not present on this object"); }
import { tracked } from "@glimmer/tracking";
import BaseSectionLink from "discourse/lib/sidebar/base-community-section-link";
import I18n from "discourse-i18n";
let EverythingSectionLink = (_class = (_EverythingSectionLink_brand = /*#__PURE__*/new WeakSet(), class EverythingSectionLink extends BaseSectionLink {
  constructor() {
    super(...arguments);
    _classPrivateMethodInitSpec(this, _EverythingSectionLink_brand);
    _initializerDefineProperty(this, "totalUnread", _descriptor, this);
    _initializerDefineProperty(this, "totalNew", _descriptor2, this);
    _assertClassBrand(_EverythingSectionLink_brand, this, _refreshCounts).call(this);
  }
  onTopicTrackingStateChange() {
    _assertClassBrand(_EverythingSectionLink_brand, this, _refreshCounts).call(this);
  }
  get showCount() {
    return this.currentUser?.sidebarShowCountOfNewItems;
  }
  get name() {
    return "everything";
  }
  get query() {
    return {
      f: undefined
    };
  }
  get title() {
    return I18n.t("sidebar.sections.community.links.topics.title");
  }
  get text() {
    return I18n.t(`sidebar.sections.community.links.${this.overridenName.toLowerCase()}.content`, {
      defaultValue: this.overridenName
    });
  }
  get currentWhen() {
    return "discovery.latest discovery.new discovery.unread discovery.top";
  }
  get badgeText() {
    if (!this.showCount) {
      return;
    }
    if (_classPrivateGetter(_EverythingSectionLink_brand, this, _get_newNewViewEnabled) && _classPrivateGetter(_EverythingSectionLink_brand, this, _get_unreadAndNewCount) > 0) {
      return _classPrivateGetter(_EverythingSectionLink_brand, this, _get_unreadAndNewCount).toString();
    } else if (this.totalUnread > 0) {
      return I18n.t("sidebar.unread_count", {
        count: this.totalUnread
      });
    } else if (this.totalNew > 0) {
      return I18n.t("sidebar.new_count", {
        count: this.totalNew
      });
    }
  }
  get route() {
    if (this.currentUser?.sidebarLinkToFilteredList) {
      if (_classPrivateGetter(_EverythingSectionLink_brand, this, _get_newNewViewEnabled) && _classPrivateGetter(_EverythingSectionLink_brand, this, _get_unreadAndNewCount) > 0) {
        return "discovery.new";
      } else if (this.totalUnread > 0) {
        return "discovery.unread";
      } else if (this.totalNew > 0) {
        return "discovery.new";
      }
    }
    return "discovery.latest";
  }
  get defaultPrefixValue() {
    return "layer-group";
  }
  get suffixCSSClass() {
    return "unread";
  }
  get suffixType() {
    return "icon";
  }
  get suffixValue() {
    if (!this.showCount && (this.totalUnread || this.totalNew)) {
      return "circle";
    }
  }
}), (_descriptor = _applyDecoratedDescriptor(_class.prototype, "totalUnread", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "totalNew", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return 0;
  }
})), _class);
function _refreshCounts() {
  if (!this.currentUser) {
    return;
  }
  this.totalUnread = this.topicTrackingState.countUnread();
  if (this.totalUnread === 0 || _classPrivateGetter(_EverythingSectionLink_brand, this, _get_newNewViewEnabled)) {
    this.totalNew = this.topicTrackingState.countNew();
  }
}
function _get_unreadAndNewCount(_this) {
  return _this.totalUnread + _this.totalNew;
}
function _get_newNewViewEnabled(_this2) {
  return !!_this2.currentUser?.new_new_view_enabled;
}
export { EverythingSectionLink as default };